import { render, staticRenderFns } from "./NxNav.vue?vue&type=template&id=bf27083e&scoped=true"
import script from "./NxNav.vue?vue&type=script&lang=js"
export * from "./NxNav.vue?vue&type=script&lang=js"
import style0 from "./NxNav.vue?vue&type=style&index=0&id=bf27083e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf27083e",
  null
  
)

export default component.exports